import { Link } from 'react-router-dom';
const EventsArray2024 = [ 
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/NCM_WORKSHOP-ERGODIC_THEORY_AND_FRACTALS.pdf",
        title: `National Centre for Mathematics (NCM) Workshop - Ergodic Theory and Fractals`,
        description: "National Centre for Mathematics (NCM) Department of Mathematics and Statistics, IIT Tirupati conducting a workshop on 'ERGODIC THEORY AND FRACTALS' from 09th - 21st December 2024.",
        img: 'https://files.iittp.ac.in/images/events/2024/NCM_WORKSHOP-ERGODIC_THEORY_AND_FRACTALS.png',
        dt: "9-21",
        my: "December",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/CC_AI_ML.pdf",
        title: `Certificate Course on Artificial Intelligence and Machine Learning for Foundry Industries`,
        description: "Department of Mechanical Engineering, IIT Tirupati conducting a Certificate Course on Artificial Intelligence and Machine Learning for Foundry Industries from 20th June-13th July 2024.",
        img: 'https://files.iittp.ac.in/images/events/2024/CC_AL_ML.jpeg',
        dt: "20",
        my: "June",
        glow: "No",
        duration: '',
    }, 
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/WORKSHOP_ON_BATTERY_MANUFACTURING_ECOSYSTEM_CHALLENGES_AND_OPPORTUNITIES.jpg",
        title: `UNLOCKING BATTERY INNOVATION: STAKEHOLDER MEETING ON RAPID PROTOTYPING CENTRE`,
        description: "IIT Tirupati, in collaboration with DST and IESA, is organizing an event panel discussion on 'UNLOCKING BATTERY INNOVATION: STAKEHOLDER MEETING ON RAPID PROTOTYPING CENTRE', 18th and 19th June 2024.",
        img: 'https://files.iittp.ac.in/images/events/2024/WORKSHOP_ON_BATTERY_MANUFACTURING_ECOSYSTEM_CHALLENGES_AND_OPPORTUNITIES.jpg',
        dt: "18-19",
        my: "June",
        glow: "No",
        duration: '',
    }, 
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/IKS_Symposium_Flyer_2024.png",
        title: `Methodology for Indian Psychological Research`,
        description:(
            <>
             IIT Tirupati, in association with the International Institute of Vedic Sciences (IIVS), Rishi Vatika is organising a Symposium on Indian Psychology on the theme "Methodology for Indian Psychological Research" during 8-12 July 2024.
             <Link to="https://docs.google.com/forms/d/e/1FAIpQLScltr41Z6fF-BCERGpvjt5TaJ4j6HCg45qMGrArouuKHHkJZQ/viewform?vc=0&c=0&w=1&flr=0" target="_blank"><b>To register click here..</b></Link>
        </>
        ),
        img: 'https://files.iittp.ac.in/images/events/2024/IKS_Symposium_Flyer_2024.png',
        dt: "8-12",
        my: "July",
        glow: "No",
        duration: '',
    }, 
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/Vacuum_Technology_and_Process_Applications.pdf",
        title: `Vacuum Technology and Process Applications`,
        description: 'The physics department is conducting a workshop on "Vacuum Technology and Process Applications" from 20th - 25th May 2024',
        img: 'https://files.iittp.ac.in/images/events/2024/Vacuum_Technology_and_Process_Applications.png',
        dt: "20-25",
        my: "May",
        glow: "No",
        duration: '',
    },   
    {
        venue: 'IIT Tirupati - AB1',
        link: "https://files.iittp.ac.in/images/events/2024/BookExhibition2024Full.png",
        title: `Book exhibition on World Book and Copyright Day`,
        description: 'The central library, IIT Tirupati, is celebrating World Book and Copyright Day; for this, a one-day book exhibition, is being organised on 23rd April 2024.',
        img: 'https://files.iittp.ac.in/images/events/2024/BookExhibition2024.png',
        dt: "23",
        my: "April",
        glow: "No",
        duration: '9AM to 9PM',
    },   
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/5K_Run_Brochure_2024.pdf",
        title: `5k Fitness Fusion Campus Run`,
        description: 'Indian Institute of Technology Tirupati and Sports Department is conducting a 5k Fitness Fusion Campus Run to be held on 14th April 2024',
        img: 'https://files.iittp.ac.in/images/events/2024/5K_Run_Brochure_2024.png',
        dt: "14",
        my: "Apr",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/Abstract_Brief_Bio_Dr_Narasamma.pdf",
        title: 'Special Lecture Series given by Dr. N. Narasamma on the topic "Wastewater: A Threat to the Environment Vs Resource Recovery,"',
        description: 'Indian Institute of Technology Tirupati cordially invites you to the Special Lecture Series',
        img: 'https://files.iittp.ac.in/images/events/2024/Special_Lecture_Series_Dr_Narasamma.png',
        dt: "10",
        my: "Apr",
        glow: "No",
        duration: '',
    },
    
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/IITTirupati-9th_Institute_Day_Invitation.pdf",
        title: '9th Institute Day Celebrations',
        description: 'Indian Institute of Technology Tirupati cordially invites you to the celebrarion of 9th Institute Day',
        img: 'https://files.iittp.ac.in/images/events/2024/InstituteDay.jpg',
        dt: "5",
        my: "Apr",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/IIT(Tirupati)%20&%20IIF-CET%20Training%20Program.pdf",
        title: 'Digital Manufacturing and Introduction to AI & ML',
        description: 'Certification Course on "Digital Manufacturing and Introduction to Artificial Intelligence & Machine Learning for Foundry Industry"',
        img: 'https://files.iittp.ac.in/images/events/2024/iifcet.png',
        dt: "1-2",
        my: "Apr",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/Special%20Lecture%20Series%20HSS_5_3_24.pdf",
        title: `Fiscal Federalism in India: Current Status and Challenges`,
        description: 'A special lecture by Shri K.Ramakrishna Rao; title of the talk is "Fiscal Federalism in India...',
        img: 'https://files.iittp.ac.in/images/events/2024/SPECIALLECTURESERIES2024.png',
        dt: "5",
        my: "Mar",
        glow: "No",
        duration: '',
    },

    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/National_Science_Day_Celebrations_2024.pdf",
        title: `National Science Day Celebrations 2024`,
        description: 'National Science Day Celebrations 2024',
        img: 'https://files.iittp.ac.in/images/events/2024/NationalScienceDay2024.png', 
        dt: "1 - 15",
        my: "Feb",
        glow: "No",
        duration: '',
    },

    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/Science%20Hack__4_24.pdf",
        title: `Science Hack 4 an online Project Competition from 1 Feb - 15 Mar, 2024.`,
        description: 'Science Hack 4 an online Project Competition from 1 Feb - 15 Mar, 2024.',
        img: 'https://files.iittp.ac.in/images/events/2024/SCIENCEHack4.0_2024.png', 
        dt: "1 - 15",
        my: "Feb",
        glow: "No",
        duration: '',
    },



    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/Workshop_10-2-2024.pdf",
        title: `Department of Humanities and Social Sciences in collaboration with the Philosophy Department`,
        description: 'Department of Humanities and Social Sciences in collaboration with the Philosophy Department at SIAS, Krea University is organising a One-Day Workshop on "Reason, Feeling and Experience" on 10th February 2024.',
        img: 'https://files.iittp.ac.in/images/events/2024/Workshop2024.png', 
        dt: "10",
        my: "Feb",
        glow: "No",
        duration: '',
    },


    {
        venue: 'IIT Tirupati',
        link: "https://sites.google.com/iittp.ac.in/mtcs-2024/home",
        title: `Department of Chemistry is organizing a two-days National Conference on "Modern Trends in Chemical Sciences 2024 (MTCS 24)"`,
        description: 'The Department of Chemistry at IIT Tirupati is a newly established and budding innovation centre.',
        img: 'https://files.iittp.ac.in/images/events/MTCS2024.png',
        dt: "16 - 17",
        my: "Feb",
        glow: "No",
        duration: '2 days',
    },

    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/iitt_inauguration.jpeg",
        title: `Inauguration / Dedication of IIT Tirupati Permanent Campus to the Nation by Hon'ble Prime Minister Shri Narendra Modi.`,
        description: 'Inauguration / Dedication of IIT Tirupati Permanent Campus to the Nation by Honble Prime Minister Shri Narendra Modi.',
        img: 'https://files.iittp.ac.in/images/events/2024/IITTInauguration2024.png',
        dt: "20",
        my: "Feb",
        glow: "No",
        duration: '',
    },



    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/IWSMDS-Schedule.pdf",
        title: `Stochastic Models in Data Science`,
        description: 'Indian Society for Probability and Statistics (ISPS) in association with our Institute is organizing an International Workshop on "Stochastic Models in Data Science" on February 20, 2024.',
        img: 'https://files.iittp.ac.in/images/events/2024/IWSMDS2024.png',
        dt: "20",
        my: "Feb",
        glow: "No",
        duration: '2 days',
    },
    

    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/D_lectures_feb2024.jpeg",
        title: `'Scaling up Satyagraha: Miscalculation and Discovery'`,
        description: 'Distinguished Lecture on the topic Scaling up Satyagraha: Miscalculation and Discovery',
        img: 'https://files.iittp.ac.in/images/events/2024/D_lectures_feb2024.png', 
        dt: "21",
        my: "Feb",
        glow: "No",
        duration: '2 days',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/MPP_Open_House_Poster_25-2-24.pdf",
        title: `"For Prospective Master of Public Policy (MPP) Applicants"`,
        description: 'Open House: "For Prospective Master of Public Policy (MPP) Applicants"',
        img: 'https://files.iittp.ac.in/images/events/2024/MPP_Open_House_Poster_25-2-24.png', 
        dt: "25",
        my: "Feb",
        glow: "No",
        duration: '',
    },


    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/ncc2024/",
        title: `30th National Conference on Communications (NCC 2024), will be jointly organized by IIT Madras and IIT Tirupati.`,
        description: 'The National Conference on Communications (NCC) is the flagship conference of India in the area of Communications, Signal Processing and Networks. ',
        img: 'https://files.iittp.ac.in/images/events/NCC2024.png',
        dt: "28 Feb  -  2 Mar",
        my: "Mar",
        glow: "No",
        duration: '3 days',
    },

    
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2024/RMMDA_Workshop%20Brochure.pdf",
        title: `Research Methodology and Multivariate Data Analysis`,
        description: 'Department of Humanities and Social Sciences is organising a 5-day Workshop on "Research Methodology and Multivariate Data Analysis" from 20-24 May, 2024.',
        img: 'https://files.iittp.ac.in/pdfs/events/2024/RMMDA_Workshop%20Brochure.pdf',
        dt: "20 - 24",
        my: "May",
        glow: "No",
        duration: '4 days',
    }


]

export default EventsArray2024;